export default {
  appName: "Qualy",
  appAPIAssets: "https://qualy.assets.s3.eu-west-2.amazonaws.com/",
  googleApiKey: "AIzaSyC0POAHa9__OO7WLBWck9T4u6R-qQv-T-4",
  appURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://admin.qualy.co.uk",
  appAPI:
    process.env.NODE_ENV === "development"
      ? "http://localhost:8081/api/v1.0"
      : "https://api.qualy.co.uk/api/v1.0",
};

// export default {
//   appName: "Qualy",
//   appAPIAssets: "https://qualy.assets.s3.eu-west-2.amazonaws.com/",
//   googleApiKey: "AIzaSyC0POAHa9__OO7WLBWck9T4u6R-qQv-T-4",
//   appURL:
//     process.env.NODE_ENV === "development"
//       ? "http://localhost:3000"
//       : "https://dev-admin.qualy.co.uk",
//   appAPI:
//     process.env.NODE_ENV === "development"
//       ? "http://localhost:8081/api/v1.0"
//       : "https://dev-api.qualy.co.uk/api/v1.0",
// };
